<template>
  <div class="login">
    <div class="loginTop">
      <div class="loginLogo warp">
        <div class="loginImgBox" @click="goToIndex">
          <img src="@/assets/images/dlogo.png" alt="" />
        </div>
        <span>欢迎商家入驻</span>
      </div>
    </div>

    <div class="loginCent" >
      <div class="loginBox warp" >
        <div class="leftImg">
          <img src="@/assets/images/banner.png" alt="" />
        </div>
        <div class="loginForm" >
          <div class="loginTit" >商家入驻基本信息表</div>

          <div class="loginFormBox" >
            <div class="inputBox">
              <label>申请人姓名</label>
              <el-input v-model="name" placeholder="请输入申请人姓名"></el-input>
            </div>
            <div class="inputBox" style="margin-top: 0px;">
              <label>申请人邮箱</label>
              <el-input v-model="email" placeholder="请输入申请人邮箱"></el-input>
            </div>
            <div class="inputBox">
              <label>手机号码</label>
              <el-input v-model="phone" placeholder="请输入手机号码"></el-input>
            </div>

            <div class="inputBox">
              <label>公司全称</label>
              <el-input  v-model="corporateName" placeholder="请输入公司全称"></el-input>
            </div>

            <div class="inputBox">
              <label>公司注册地址</label>
              <el-input v-model="corporateAdderss" placeholder="请输入公司注册地址"></el-input>
            </div>
            <div class="inputBox">
              <label>公司法人姓名</label>
              <el-input v-model="corporateFullName" placeholder="请输入公司法人姓名"></el-input>
            </div>
            <div class="inputBox">
              <label>公司法人身份证号</label>
              <el-input v-model="IDCard" placeholder="请输入公司法人身份证号"></el-input>
            </div>
            <div class="inputBox">
              <label>上传营业执照附件</label>
                <el-upload
                  ref="uploadExcel"
                  :action="action"
                  :limit=5
                  :auto-upload="true"
                  :before-upload="handleBeforeUpload"
                  :on-preview="handleOnPreview"
                  :on-change="fileChange"
                  :on-exceed="exceedFile"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :on-remove="removeFile"
                  :file-list="fileList">
                  <el-button size="small" plain  type="info">选择文件</el-button>
                </el-upload>
            </div>
            <div class="loginBtn" @click="login" >提交</div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookie from "js-cookie";
import api from "../../api";
import { listSearchMixin } from "../../config/mixin";
import { mapMutations } from "vuex";
import md5 from 'js-md5';



export default {
  name: "login",
  mixins: [listSearchMixin],
  data() {
    return {
      action: api.upload,
      urls: null,
      fileList:[],

      name : "",
      email : "",
      phone : "",
      corporateName : "",
      corporateAdderss : "",
      corporateFullName : "",
      IDCard : "",

	  }
  },

  methods: {


    handleOnPreview(file) {
      let a = document.createElement('a')
      let event = new MouseEvent('click')
      a.download = '下载图片名称'
      a.target = '_blank'
      a.href = !file.link ? file.response.link: file.link
      a.dispatchEvent(event)
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$notify.success({
        title: '成功',
        message: `文件上传成功`
      });
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '错误',
        message: `文件上传失败`
      });
    },
    exceedFile(files, fileList) {
      this.$notify.warning({
        title: '警告',
        message: `只能选择5个文件，当前共选择了 ${files.length + fileList.length} 个`
      });
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      this.fileList = fileList
    },
    removeFile(file,fileList) {
      this.fileList = fileList
    },
    handleBeforeUpload(file){
      let size = file.size / 1024 / 1024
      if(size > 20) {
        this.$notify.warning({
          title: '警告',
          message: '文件大小必须小于20M'
        })
      }
    },

    goToIndex() {
      this.$router.push({ path: "/" });
    },

    login() {
      if (this.name === "") {
        this.$message({
          message: "请输入申请人姓名",
          type: "error",
          duration: 3000
        });
        return;
      }

      if (this.email === "") {
        this.$message({
          message: "请输入申请人邮箱",
          type: "error",
          duration: 3000
        });
        return;
      }

      if (this.phone === "") {
        this.$message({
          message: "请输入手机号码",
          type: "error",
          duration: 3000
        });
        return;
      }

      if (this.corporateName === "") {
        this.$message({
          message: "请输入公司全称",
          type: "error",
          duration: 3000
        });
        return;
      }

      if (this.corporateAdderss === "") {
        this.$message({
          message: "请输入公司注册地址",
          type: "error",
          duration: 3000
        });
        return;
      }

      if (this.corporateFullName === "") {
        this.$message({
          message: "请输入公司法人姓名",
          type: "error",
          duration: 3000
        });
        return;
      }

      if (this.IDCard === "") {
        this.$message({
          message: "请输入公司法人身份证号",
          type: "error",
          duration: 3000
        });
        return;
      }

      this.$message({
        message: "资料提交成功，我们将第一时间进行审核~",
        type: "success",
        duration: 5000
      });
    },

  },
};
</script>

<style lang="scss" scoped>
	.forgetCodeBtn {
		padding: 0 10px;
		background: #eeeeee;
		border-radius: 4px;
		font-size: 12px;
		position: absolute;
		right: 0;
		cursor: pointer;
		color: #000;
	}
	.forgetPwd {
		position: absolute;
		right: 5px;
		top: 42px;
		font-size: 12px;
		color: #f9bc84;
	}
.login {
  height: 100vh;
  display: flex;
  flex-direction: column;
  min-height: 768px;
  .loginTop {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 999;
    flex-shrink: 0;
    .loginLogo {
      display: flex;
      align-items: center;
      height: 88px;
      img {
        width: 180px;
        margin-right: 30px;
      }
      span {
        font-size: 18px;
        color: $fontColor;
      }
      .loginImgBox {
        width: 200px;
        height: 40px;
        align-items: center;
        display: flex;
        margin-right: 20px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
    }
  }
  .loginCent {
    background-color:#faf7f5;
    flex-grow: 1;
    background-size: cover;
    display: flex;
    align-items: center;
    .loginBox {
      display: flex;
      align-items: center;
      position: relative;
    }
    .leftImg {
      width: 760px;
      height: 490px;
    }
    .loginForm {
      width: 540px;
      background: #ffffff;
      box-shadow: 0px 15px 14px 2px rgba(162, 87, 20, 0.15);
      border-radius: 20px;
      position: absolute;
      right: 0;
      .loginTit {
        height: 50px;
        display: flex;
        align-items: center;
        font-size: 30px;
        color: $mainColor;
        width: 100%;
        justify-content: center;
        margin: 70px 0;
        &:before {
          content: "";
          height: 2px;
          width: 98px;
          display: block;
          background: url("../../assets/images/dzuo.png") no-repeat;
          margin-right: 27px;
        }
        &:after {
          content: "";
          height: 2px;
          width: 98px;
          display: block;
          background: url("../../assets/images/dyou.png") no-repeat;
          margin-left: 27px;
        }
      }
      .loginTab {
        height: 50px;
        display: flex;
        align-items: flex-start;
        font-size: 15px;
        color: #000;
        justify-content: space-between;
        flex-direction: row;
        padding: 0 25%;
        .active {
          color: $mainColor;
          position: relative;
        }
        // .active::after{
        //   position: absolute;
        //   bottom: -6px;
        //   left: 72px;
        //   right: 72px;
        //   height: 4px;
        //   content: '';
        //   background: $mainColor;
        //   border-radius: 2px;
        // }
      }
      .loginFormBox {
        padding: 0 60px;
        .inputBox {
          position: relative;
          label {
            color: $fontColor;
            font-size: 18px;
            font-weight: 500;
          }
          >>> .el-input__inner {
            height: 64px;
            border: none;
            border-bottom: 1px solid #eeeeee;
            font-size: 20px;
            color: #666666;
            padding-left: 0;
          }
          &:nth-child(2) {
            margin: 60px 0 20px 0;
          }
          .codeBtn {
            width: 140px;
            height: 54px;
            background: #eeeeee;
            border-radius: 4px;
            display: block;
            line-height: 54px;
            text-align: center;
            position: absolute;
            right: 0;
            bottom: 10px;
            cursor: pointer;
          }
          .codeCount {
            color: #999999;
          }
        }
        .noLogin {
          color: #333333;
          font-size: 18px;
          margin: 20px 0 60px 0;
          height: 30px;
          align-items: center;
          display: flex;
          justify-content: space-between;
          >>> .el-checkbox__label {
            font-size: 16px;
            color: #333333;
            font-weight: 400;
          }
          span {
            cursor: pointer;
            font-size: 16px;
            text-decoration: underline;
            color: #666666;
          }
        }
        .registered {
          justify-content: flex-end;
        }
        .loginBtn {
          width: 100%;
          background: $mainColor;
          height: 60px;
          line-height: 60px;
          border-radius: 27px;
          text-align: center;
          font-size: 20px;
          color: #ffffff;
          // margin-bottom: 60px;
          margin-bottom: 20px;
          margin-top: 20px;
          cursor: pointer;
        }
      }
      .loginProtocol {
        padding: 0 60px;
        display: flex;
        // align-items: center;
        height: 80px;
        line-height: 80px;
        border-top: 1px solid #eeeeee;
        span {
          margin-left: 10px;
        }
		.loginAgree{
			width: 45%;
			font-size: 15px;
			color: #426bea;
			cursor: pointer;
		}
		.loginAgree:hover {
			color: #2b72ff;
		}
        // span:nth-child(3) {
        //   color: #426bea;
        //   cursor: pointer;
        // }
      }
      >>> .el-checkbox__inner {
        width: 20px;
        height: 20px;
        &:after {
          height: 10px;
          left: 7px;
          width: 4px;
        }
      }
    }
  }
  >>> .el-dialog__body {
    max-height: 500px;
    min-height: 300px;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settled/settled.vue